import { Icon1C } from '@direct-frontend/components';
import { type OpenApiSchemaIntegrationType } from '#shared/api/schema';
import { INTEGRATION_TYPE_1C, isSupportedIntegrationType } from '#shared/lib/integrations';
import { getIntegrationSourceData } from './integrationSourceData';

export const getIconByIntegrationType = (type: OpenApiSchemaIntegrationType | undefined) => {
    if (!type || !isSupportedIntegrationType(type)) {
        return { Icon: null };
    }

    if (type === INTEGRATION_TYPE_1C) {
        return { Icon: Icon1C };
    }

    return { Icon: getIntegrationSourceData(type).LogoIcon };
};
